import type { Slice } from '@reduxjs/toolkit';

import { createHydrateSliceAction, extractReducerRehydrationInfo } from './hydration';

/**
 * Патч для редьюсера слайса.
 * Добавляет во все слайсы обработку экшена гидрации данными, полученными при SSR.
 */
export function patchSliceReducer<CreatedSlice extends Slice>(
    moduleName: string,
    slice: CreatedSlice
): CreatedSlice['reducer'] {
    const hydrateSliceAction = createHydrateSliceAction(slice.name);

    return (state, action) => {
        if (hydrateSliceAction.match(action)) {
            // slice.name уже содержит moduleName, поэтому отрезаем его.
            const sliceName = slice.name.slice(moduleName.length + 1);

            return extractReducerRehydrationInfo(moduleName, sliceName) || state;
        }

        return slice.reducer(state, action);
    };
}
